import React, { useState } from 'react';
import { IpaType } from '../phonemes/ipa';
import { ComparisonChart } from './chart/ComparisonChart';
import { ChoiceList } from './widgets/ChoiceList';
import { Segments } from './chart/Segments';
import { SegmentFeatures } from './chart/SegmentFeatures';
import { getPhoibleUrl } from '../world/languageToPhoibleId';
import { TrackLanguageFeatures } from '../world/trackLanguageFeatures';

const only1 = 'rgb(255,200,200)';
const only2 = 'rgb(200,255,200)';

/** UI for picking two languages to compare their supported phonemes */
export function LanguageToLanguageCharts(props: {
  readonly trackers: TrackLanguageFeatures;
  /** called when a symbol is clicked on */
  readonly clicked?: (ipa: IpaType) => void;
  /** true if a call to 'clicked' will do something useful */
  readonly canClick?: (ipa: IpaType) => boolean;
}) {
  const [languageList] = useState(props.trackers.sortedByName());
  const [language1, setLanguage1] = useState('American English');
  const [language2, setLanguage2] = useState('French');
  const [stats1, setStats1] = useState(props.trackers.lookupStats(language1));
  const [stats2, setStats2] = useState(props.trackers.lookupStats(language2));
  const [hoveredSegment, setHoveredSegment] = useState('');

  function changeLanguage1(l: string) {
    setLanguage1(l);
    setStats1(props.trackers.lookupStats(l));
  }
  function changeLanguage2(l: string) {
    setLanguage2(l);
    setStats2(props.trackers.lookupStats(l));
  }

  const phoibleId1 = getPhoibleUrl(language1);
  const link1 = phoibleId1 === null ? "reference link" : <a href={phoibleId1}>reference link</a>;
  const phoibleId2 = getPhoibleUrl(language2);
  const link2 = phoibleId2 === null ? "reference link" : <a href={phoibleId2}>reference link</a>;

  return (<div>
    <span style={{ backgroundColor: only1 }}>one</span>&nbsp;
    <ChoiceList items={languageList} selectedItem={language1} onSelect={changeLanguage1} />
    &nbsp;&nbsp;{link1}
    <br />

    <span style={{ backgroundColor: only2 }}>two</span>&nbsp;
    <ChoiceList items={languageList} selectedItem={language2} onSelect={changeLanguage2} />
    &nbsp;&nbsp;{link2}
    <br />

    <ComparisonChart ipa1={stats1.chartIpa} ipa2={stats2.chartIpa} only1={only1} only2={only2} clicked={props.clicked} canClick={props.canClick} />
    <br />
    <BreakdownChart segments1={stats1.segmentList} segments2={stats2.segmentList} onMouseOver={(ipa) => setHoveredSegment(ipa)} />
    <br />
    <SegmentFeatures segment={hoveredSegment} />
  </div>);
}

interface BreakdownChartProps {
  readonly segments1: IpaType[];
  readonly segments2: IpaType[];
  readonly onMouseOver: (ipa: IpaType) => void;
}

/** show breadown of segments in both languages & in just one language */
function BreakdownChart(props: BreakdownChartProps) {
  const segments1 = props.segments1;
  const segments2 = props.segments2;
  const both = segments1.filter(p => segments2.includes(p));
  const just1 = segments1.filter(p => !segments2.includes(p));
  const just2 = segments2.filter(p => !segments1.includes(p));
  return (<table>
    <tbody>
      <tr>
        <th>both</th>
        <Segments segments={both} onMouseOver={props.onMouseOver} />
      </tr><tr>
        <th style={{ backgroundColor: only1 }}>only 1</th>
        <Segments segments={just1} onMouseOver={props.onMouseOver} />
      </tr><tr>
        <th style={{ backgroundColor: only2 }}>only 2</th>
        <Segments segments={just2} onMouseOver={props.onMouseOver} />
      </tr>
    </tbody>
  </table>);
}
